// extracted by mini-css-extract-plugin
export default {"carousel-container":"Carousel_carousel-container__5at83","carousel-item":"Carousel_carousel-item__BZ7q1"};